import Rental from './blocks/Rental'
import RentalList from './blocks/RentalList'

export const dynamicBlocks = {
  rental: Rental,
  rentalList: RentalList
}
